import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Footer } from '../index';
import usePerformanceMonitor from '../../hooks/usePerformanceMonitor';

// Import components directly instead of lazy loading
import Hero from '../features/Hero';
import Services from '../features/Services';
import Portfolio from '../features/Portfolio';
import Reviews from '../features/Reviews';
import About from '../features/About';
import Contact from '../forms/Contact';


const HomePage = () => {
  // Monitor performance metrics
  const performanceMetrics = usePerformanceMonitor();

  return (
    <>
      <Helmet>
        <title>RC Remodel - Professional Home Remodeling & Renovation Services | Licensed Contractors</title>
        <meta name="description" content="RC Remodel - Top-rated home remodeling contractors specializing in kitchen renovations, bathroom remodels, full home renovations, and custom construction. 12+ years experience, 400+ completed projects. Licensed & insured. Free estimates available." />
        <meta name="keywords" content="home remodeling, kitchen renovation, bathroom remodel, home improvement, construction contractor, general contractor, residential renovation, custom home building, licensed contractor, home renovation near me, remodeling contractors, kitchen remodel, bathroom renovation" />
        <link rel="canonical" href="https://rcremodel.com/" />
        
        {/* Open Graph */}
        <meta property="og:title" content="RC Remodel - Professional Home Remodeling & Renovation Services" />
        <meta property="og:description" content="Top-rated home remodeling contractors with 12+ years experience. Kitchen renovations, bathroom remodels, full home renovations. Licensed & insured. Free estimates." />
        <meta property="og:url" content="https://rcremodel.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://rcremodel.com/images/hero/hero1.webp" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="RC Remodel - Professional Home Remodeling Services" />
        <meta name="twitter:description" content="Top-rated home remodeling contractors with 12+ years experience. Licensed & insured. Free estimates." />
        <meta name="twitter:image" content="https://rcremodel.com/images/hero/hero1.webp" />
      </Helmet>
      <main id="main-content">
        <Hero />
        <Services />
        <Portfolio />
        <Reviews />
        <About />
        <Contact />
        <Footer />
      </main>
    </>
  );
};

export default HomePage;
